import React, { useState, useRef, useEffect } from 'react';
import { Container, Button, Form, Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';

const BusinessTopbar = ({ toggleSidebar }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [expanded, setExpanded] = useState(false);
  const navRef = useRef(null);

  // Close navbar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const [showInfo, setShowInfo] = useState(false);
  const handleInfo = () => {
    setShowInfo(prev => !prev);
  };


  return (
    <>
      <div className='info-box d-none'>
        <Row className='info-top'>
          <Col><p>Weekend plans need a little extra? extra 15% off should help!</p></Col>
          <Col xs="auto"><Link to="" onClick={handleInfo}> <span> {showInfo ? 'Hide Detail' : 'View Detail'} </span> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className={`img-fluid ${showInfo ? 'tr180' : ''}`} alt="drop-wh" /></Link></Col>
        </Row>
        {showInfo && (
          <div className='info-bot'>
            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/info.webp'} className="img-fluid" alt="info" />
            <p>jsdjk sjksjkl jsdkljf sdkljfklsdnkljnsdklfj sdkljklsdjfksjfkljsdlkj</p>
          </div>
        )}
      </div>    
      <section>
        <Container>
          <div className='nei-header before-login-header org-header'>
            <div>
              <div className='header-loc-box'>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location-wh.webp'} className="img-fluid  d-none" alt="location-wh" />
                <h6 className='d-none'>Nasik Local</h6>
                <Link to="" onClick={handleShow} className='d-none'>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search-wh.webp'} className="img-fluid" alt="search-wh" />
                </Link>
              </div>
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic" className='header-user-box'>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/user.webp'} className="img-fluid" alt="user" />
                </Dropdown.Toggle>

                <Dropdown.Menu className='header-drop'>
                  <Link to="/neighbour/login">
                    <div>
                      <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/loginnew.webp'} className="img-fluid" alt="profile" />
                      <h6>Neighbor Sign In</h6>
                    </div>
                  </Link>
                  <Link to="/neighbour/register">
                    <div>
                      <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/signup.webp'} className="img-fluid" alt="profile" />
                      <h6>Neighbor Sign Up</h6>
                    </div>
                  </Link>
                  <Link to="/business/register">
                    <div>
                      <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/userline.webp'} className="img-fluid" alt="ian" />
                      <h6>Register a Business</h6>
                    </div>
                  </Link>
                  {/* <Link to="/neighbour/contact-us">
                    <div>
                      <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cnt.webp'} className="img-fluid" alt="cnt" />
                      <h6>Contact Us</h6>
                    </div>
                  </Link> */}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className=''>
              <Navbar expand="lg" expanded={expanded} onToggle={setExpanded} ref={navRef} className="bg-body-tertiary">
                <Container>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/logo-busi.webp'} className="img-fluid logo-bl" alt="logo-bl" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      <Nav.Link href="/">
                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/logo-busi.webp'} className="img-fluid logo-nei" alt="logo-nei" />
                      </Nav.Link>
                    </Nav>
                  </Navbar.Collapse>
                </Container>
              </Navbar>
            </div>
          </div>
        </Container>
      </section>          
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className='add-city-modal'
      >
        <Modal.Header closeButton>
          <h3>Search Location</h3>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className='d-none'>Pin code</Form.Label>
              <Form.Control type="text" placeholder="Pin code" />
            </Form.Group>
            <div className='or-box'>
              <span>or</span>
            </div>
            <Form.Select aria-label="Default select example">
              <option>State</option>
              <option value="nashik">Maharastra</option>
              <option value="ratnagiri">Gujarat</option>
              <option value="nagpur">Karnataka</option>
            </Form.Select>
            <Form.Select aria-label="Default select example">
              <option>District</option>
              <option value="nashik">Nashik</option>
              <option value="ratnagiri">Ratnagiri</option>
              <option value="nagpur">Nagpur</option>
              <option value="ahmedabad">Ahmedabad</option>
              <option value="surat">Surat</option>
              <option value="gandhinagar">Gandhinagar</option>
              <option value="bengaluru">Bengaluru</option>
              <option value="mysuru">Mysuru</option>
              <option value="udupi">Udupi</option>
            </Form.Select>
            <Form.Select aria-label="Default select example">
              <option>Town</option>
              <option value="belur">Belur</option>
              <option value="aldur">Aldur</option>
              <option value="hornadu">Hornadu</option>
              <option value="dapoli">Dapoli</option>
              <option value="khed">Khed</option>
              <option value="bhor">Bhor</option>
            </Form.Select>
            <Button type="submit" className='blue-btn'>Select Location</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default BusinessTopbar;                    